<script>
import taxonomyForm from "@/views/menu/taxonomy/taxonomyForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    taxonomyService: "taxonomyService",
    fileUploadService: "fileUploadService",
    toastService: "toastService",
  },
})
export default class TaxonomyEdit extends mixins(taxonomyForm) {
  formId = "edit-taxonomy-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        disabled: () => {
          return this.fileUploadService.isUploading();
        },
        handle: this.save,
      },
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
      this.model.localizations.forEach((loc) => {
        if (!loc.name) {
          loc.name = "";
        }
      });
      await this.taxonomyService.update(
        this.model.id,
        this.model
      );
      this.$router.push("/taxonomy/list");
      this.toastService.success(this.translations.success.taxonomy_edit);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.taxonomies_edit;
  }

  async afterCreate() {
    this.model = await this.taxonomyService.read(this.$route.params.id);
    this.isReady = true;
  }
}
</script>
